import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { langProps, textOf } from './lang';
import { TONE_BG, type Tone } from './tones';

/**
 * Slanted headline plate at the wordmark's angle (-7 deg). The box skews, the text does not.
 *
 *   <Plate as="h1" tone="butter" size="lg">Leaderboards</Plate>
 */
export type PlateSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE: Record<PlateSize, string> = {
  sm: 'text-sm',
  md: 'text-xl',
  lg: 'text-3xl',
  xl: 'text-5xl',
};

export interface PlateProps {
  children: ReactNode;
  tone?: Tone;
  size?: PlateSize;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'div' | 'span' | 'p';
  className?: string;
  id?: string;
}

export function Plate({ children, tone = 'white', size = 'md', as: As = 'h2', className, id }: PlateProps) {
  return (
    <As
      id={id}
      className={clsx('tts-plate tts-display self-start', TONE_BG[tone], SIZE[size], className)}
      {...langProps(textOf(children))}
    >
      <span>{children}</span>
    </As>
  );
}
